/** Client-side persistence keys (namespaced for Orbeat). */

const LEGACY = {
  orbeat_high_scores: 'ripple_high_scores',
  orbeat_audio_music_enabled: 'ripple_audio_music_enabled',
  orbeat_last_mode: 'ripple_last_mode',
  orbeat_difficulty: 'ripple_difficulty',
  orbeat_universes: 'ripple_universes',
  orbeat_auth_token: 'ripple_auth_token',
  orbeat_device_id: 'ripple_device_id'
};

export const STORAGE = {
  HIGH_SCORES: 'orbeat_high_scores',
  SONG_BEST: 'orbeat_song_best',
  AUDIO_MUSIC_ENABLED: 'orbeat_audio_music_enabled',
  LAST_MODE: 'orbeat_last_mode',
  DIFFICULTY: 'orbeat_difficulty',
  UNIVERSES: 'orbeat_universes',
  AUTH_TOKEN: 'orbeat_auth_token',
  DEVICE_ID: 'orbeat_device_id'
};

export function storageGet(key) {
  try {
    let value = localStorage.getItem(key);
    const legacy = LEGACY[key];
    if (value == null && legacy) {
      value = localStorage.getItem(legacy);
      if (value != null) localStorage.setItem(key, value);
    }
    return value;
  } catch {
    return null;
  }
}

export function storageSet(key, value) {
  try {
    localStorage.setItem(key, value);
  } catch {
    /* quota / private mode */
  }
}

export function storageRemove(key) {
  try {
    localStorage.removeItem(key);
  } catch {
    /* ignore */
  }
}
